module.exports = __webpack_public_path__ + "static/demo-178b2dea66111aa1e748f1158430d6c5.mp4";